<div>
  <div class="header" (swipedown)="swipe($event.type)">
    <div class="title">
      <img src="assets/shop/off.svg" alt="" />

      <p>کد تخفیف</p>
    </div>
    <img src="assets/cookingbook/angle-down.svg" (click)="goBack()" alt="" />
  </div>
  <img class="gift" src="assets/shop/gift.svg" alt="" />
  <div class="body">
    <p>شما میتوانید کد تخفیف یا هدیه خودرا در کادر زیر وارد و ثبت کنید</p>
    <div class="code" [ngClass]="{invalidCode}">
      <span class="invalidCode" [ngClass]="{invalidCode}">کد</span>

      <input
        (ngModelChange)="change()"
        type="text"
        name=""
        id=""
        [(ngModel)]="code"
      />
      <img
        [src]="
          !invalidCode
            ? 'assets/shop/off.svg'
            : 'assets/authentication/error.svg'
        "
        alt=""
      />
    </div>
    <p
      [ngStyle]="{
        margin: '0px',
        'margin-top': '5px',
        visibility: invalidCode ? 'visible' : 'hidden'
      }"
      class="invalidCode"
    >
      کد تخفیف وارد شده نامعتبر است
    </p>
    <div class="button" (click)="submit()">ثبت کن</div>
  </div>
</div>
